import React, { useState } from 'react';
import { userRoles } from '../utility/ReUsableFunctions';
import { MenuItem } from './types';
import { URL } from '../../api/tklEnvironments';
// Replace custom icon imports with Lucide React icons
import { 
  Grid3X3, 
  Infinity, 
  Users, 
  Trophy, 
  Settings,
  HelpCircle
} from 'lucide-react';

const communityMenuItems: MenuItem[] = [
  {
    id: 'main-nav',
    title: 'Main Navigation',
    icon: React.createElement(Grid3X3, { 
      size: 20, 
      color: "#E8EAED" 
    }),
    styles: { marginTop: '-8px', marginBottom: '0' },
    children: [
      {
        id: 'dashboard',
        title: 'PD Dashboard',
        link: '/',
        requiredRoles: [
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_ADMIN,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ],
        icon: React.createElement('i', { className: 'material-icons', style: { fontSize: 20, color: "#E8EAED" } }, 'dashboard')
      },
      {
        id: 'the-loop',
        title: 'The Loop',
        link: '/the-loop',
        requiredRoles: [userRoles.TKL_MEMBER_FREE_USER],
        icon: React.createElement(Infinity, { 
          size: 20, 
          color: "#E8EAED" 
        })
      }
    ]
  },
  {
    id: 'engagement-learning',
    title: 'Engagement & Learning',
    icon: React.createElement(Users, {
      size: 20,
      color: "#E8EAED"
    }),
    styles: { marginBottom: '0' },
    children: [
      {
        id: 'my-colleagues',
        title: 'My Colleagues',
        link: '/colleagues',
        requiredRoles: [userRoles.TKL_MEMBER_FREE_USER]
      },
      {
        id: 'forums',
        title: 'Forums',
        link: '/the-loop#forums',
        requiredRoles: [userRoles.TKL_MEMBER_FREE_USER]
      },
      {
        id: 'monthly-poll',
        title: 'Monthly Poll',
        link: '/all_polls',
        requiredRoles: [userRoles.TKL_MEMBER_FREE_USER]
      },
    ]
  },
  {
    id: 'leaderboard',
    title: 'Leaderboard',
    icon: React.createElement(Trophy, {
      size: 20,
      color: "#E8EAED"
    }),
    styles: { marginBottom: '0' },
    children: [
      {
        id: 'my-ranking',
        title: 'My Ranking',
        link: '/rewards',
        requiredRoles: [
          userRoles.TKL_MEMBER_FREE_USER,
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.INVITED_USER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.SCHOOL_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'monthly-challenges',
        title: 'Monthly Challenges',
        link: '/challenges',
        requiredRoles: [
          userRoles.TKL_MEMBER_FREE_USER,
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.INVITED_USER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.SCHOOL_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'rewards',
        title: 'Rewards',
        link: '/rewards',
        requiredRoles: [
          userRoles.TKL_MEMBER_FREE_USER,
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.INVITED_USER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.SCHOOL_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'my-badges',
        title: 'My Badges',
        link: '/badges',
        requiredRoles: [
          userRoles.TKL_MEMBER_FREE_USER,
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.INVITED_USER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.SCHOOL_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'faqs',
        title: 'FAQs',
        link: '/faq',
        requiredRoles: [
          userRoles.TKL_MEMBER_FREE_USER,
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.INVITED_USER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.SCHOOL_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      }
    ]
  },
  {
    id: 'leaderboard-actions',
    title: 'Leaderboard Admin',
    icon: React.createElement(Settings, { 
      size: 20, 
      color: "#E8EAED" 
    }),
    children: [
      {
        id: 'leaderboards-tab',
        title: 'Rewards',
        link: '/leaderboards?tab=rewards',
        requiredRoles: [
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'user-actions-tab',
        title: 'User Actions',
        link: '/leaderboards?tab=user-actions',
        requiredRoles: [
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'analytics-tab',
        title: 'Analytics',
        link: '/leaderboards?tab=analytics',
        requiredRoles: [
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'faq-management-tab',
        title: 'FAQ Management',
        link: '/leaderboards?tab=faq',
        requiredRoles: [
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      }
    ]
  },
  {
    id: 'resources-tools',
    title: 'Resources & Tools',
    icon: React.createElement('svg', {
      width: "24",
      height: "24", 
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    React.createElement('path', {
      d: "M8 20C7.45 20 6.97917 19.8042 6.5875 19.4125C6.19583 19.0208 6 18.55 6 18V15H9V12.75C8.41667 12.7167 7.8625 12.5875 7.3375 12.3625C6.8125 12.1375 6.33333 11.8 5.9 11.35V10.25H4.75L1.5 7C2.1 6.23333 2.84167 5.69167 3.725 5.375C4.60833 5.05833 5.5 4.9 6.4 4.9C6.85 4.9 7.2875 4.93333 7.7125 5C8.1375 5.06667 8.56667 5.19167 9 5.375V4H21V17C21 17.8333 20.7083 18.5417 20.125 19.125C19.5417 19.7083 18.8333 20 18 20H8ZM11 15H17V17C17 17.2833 17.0958 17.5208 17.2875 17.7125C17.4792 17.9042 17.7167 18 18 18C18.2833 18 18.5208 17.9042 18.7125 17.7125C18.9042 17.5208 19 17.2833 19 17V6H11V6.6L17 12.6V14H15.6L12.75 11.15L12.55 11.35C12.3167 11.5833 12.0708 11.7917 11.8125 11.975C11.5542 12.1583 11.2833 12.3 11 12.4V15ZM5.6 8.25H7.9V10.4C8.1 10.5333 8.30833 10.625 8.525 10.675C8.74167 10.725 8.96667 10.75 9.2 10.75C9.58333 10.75 9.92917 10.6917 10.2375 10.575C10.5458 10.4583 10.85 10.25 11.15 9.95L11.35 9.75L9.95 8.35C9.46667 7.86667 8.925 7.50417 8.325 7.2625C7.725 7.02083 7.08333 6.9 6.4 6.9C6.06667 6.9 5.75 6.925 5.45 6.975C5.15 7.025 4.85 7.1 4.55 7.2L5.6 8.25ZM15 17H8V18H15.15C15.1 17.85 15.0625 17.6917 15.0375 17.525C15.0125 17.3583 15 17.1833 15 17Z",
    fill: "#E8EAED"
    })),
    styles: { marginBottom: '0' },
    children: [
      {
        id: 'my-resources',
        title: 'My Resources',
        link: '/community/resources/all-tkl-recommended-resouces',
        requiredRoles: [userRoles.TKL_MEMBER_FREE_USER]
      },
      {
        id: 'my-bookmarks',
        title: 'My Bookmarks',
        link: '/community#bookmarks',
        requiredRoles: [userRoles.TKL_MEMBER_FREE_USER]
      },
      {
        id: 'tkl-online-courses',
        title: 'TKL Online Courses',
        link: '/catalog-comprehensive',
        requiredRoles: [userRoles.TKL_MEMBER_FREE_USER]
      }
    ]
  },
  {
    id: 'contact-us',
    title: 'Contact Us',
    link: 'mailto:pd@teachnkidslearn.com',
    icon: React.createElement(HelpCircle, {
      size: 20,
      color: "#E8EAED"
    }),
    styles: { marginBottom: '0' },
    requiredRoles: [userRoles.ANY_USER],
    children: []
  }
];

export default communityMenuItems;